import { getBottomBarTemplate, getVueBottomBarTemplate } from "../../shortcodes/templates";

let bottomBarShortcode = null;
const visualizeBottomBar = content => {
  bottomBarShortcode = content.querySelectorAll('[data-wrapper-id="bottom-bar-shortcode"]');

  if (bottomBarShortcode.length > 0) {
    bottomBarShortcode.forEach(item => {
      item.innerHTML = getBottomBarTemplate();
    });
  }
};

const serializeBottomBar = content => {
  const bottomBarShortcodeWidget = content.querySelectorAll('[data-wrapper-id="bottom-bar-shortcode"]');
  if (bottomBarShortcodeWidget.length > 0) {
    bottomBarShortcodeWidget.forEach(item => {
      const bottomBarData = item.getAttribute("data-bottom-bar-data");
      item.innerHTML = getVueBottomBarTemplate(bottomBarData);
    });
  }
};

export { visualizeBottomBar, serializeBottomBar };
